export function isElementScrollableById(id: string | HTMLElement, offset: number | boolean, orientation: 'Height' | 'Width' = 'Height') {
    const element = typeof id === 'string' ? document.getElementById(id as string) : id;
    
    const scrollKey = ('scroll' + orientation) as keyof HTMLElement;
    const clientKey = ('client' + orientation) as keyof HTMLElement;
    const scrollPosition = (element ? element[scrollKey] : 0) as number;
    const clientCapacity = (element ? element[clientKey] : 0) as number;

    return typeof offset === 'number'
        ? Math.abs(scrollPosition  - clientCapacity) <= offset
        : scrollPosition > clientCapacity + 1;
}

export function typeSafeScrollTopExtraction(e: React.UIEvent<HTMLElement, UIEvent>, orientation: 'Top' | 'Left' = 'Top') {
    return e.target['scroll' + orientation as keyof EventTarget] as unknown as number;
}

export function getTextWidth(text: string, font: string, offset: number = 0) {
    const canvas = document.createElement('canvas');
    const context = canvas.getContext('2d');
  
    if (context) {
        context.font = font || '10px sans-serif';
        return context.measureText(text).width + offset;
    }

    return 0;
}      

export function extractFontById(id: string | HTMLElement) {
    if (!id)
        return {fontFamily: 'Modam Medium', fontSize: '18px'}

    const element = typeof id === 'string' ? document.getElementById(id as string) : id;

    const fontFamily = window.getComputedStyle(element as Element, null).getPropertyValue('font-family')
    const fontSize = window.getComputedStyle(element as Element, null).getPropertyValue('font-size')

    return {fontFamily: fontFamily, fontSize: fontSize}
}